<template>
    <div class="group relative flex gap-x-6 rounded-lg p-4 hover:bg-gray-50">
        <div class="mt-1 flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
            <QrIcon icon="file" class="h-6 w-6 text-gray-600 group-hover:text-brand" aria-hidden="true" />
        </div>
        <div>
            <button @click="create" class="font-semibold text-gray-900">
                {{ trans('homepage.document') }}
                <span class="absolute inset-0" />
            </button>
            <p class="mt-1 text-gray-600" v-text="trans('homepage.document_desc')"/>
        </div>
    </div>
</template>

<script setup>
import { ref } from "vue";
import QrIcon from "@/components/application-ui/elements/QrIcon.vue";
import { trans } from "@/libs/helper.js";
import { useQrCodeHomepageStore } from "@/store/qrCodeHomepage.js";
import emitter from "@/libs/emitter.js";

const emit = defineEmits(['close']);
const busy = ref(false);
const homepageStore = useQrCodeHomepageStore();

const create = async () => {
    if (busy.value) {
        return;
    }

    busy.value = true;

    const data = await homepageStore.create({
        type: 'document',
        menu_button_name: trans('homepage.document'),
        is_password_protected: false,
        password: '',
    });

    busy.value = false;
    emitter.emit('created-document', data.id);
    emit('close');
}
</script>
